<div class="gwc-social-security"
  [class.gwc-social-security--invalid]="formControl.invalid && formControl.touched">
  <code-input (codeChanged)="updateFormControl($event)"
    [code]="code"
    [codeLength]="9"
    [isCodeHidden]="true"
  ></code-input>
  
  @if (formControl.invalid && formControl.touched) {
    <div class="gwc-social-security__error">
      Please enter all 9 digits of your social security number.
    </div>
  }
</div>
